module.exports = require('./lib').default;
module.exports.default = module.exports;
module.exports.NextButton = require('./lib').NextButton;
module.exports.PreviousButton = require('./lib').PreviousButton;
module.exports.PagingDots = require('./lib').PagingDots;



//////////////////
// WEBPACK FOOTER
// ./~/nuka-carousel/index.js
// module id = 50
// module chunks = 15232829909110 45886035134291 246227742792961